module.exports = "/_next/static/images/logo-no-slogan-dark-6f0b998d4700ae6de948b7f8b3b87cb4.svg";